import type { IconProps } from '../components/IconSvg';
import { IconSvg } from '../components/IconSvg';

export function Truck(props: IconProps) {
  return (
    <IconSvg {...props}>
      <path d="M24.5 6a1.5 1.5 0 011.493 1.356L26 7.5v3.526h4c.116 0 .227.04.315.113l.062.06 3.503 4.021c.06.069.099.151.115.24l.008.089v9.977a1.5 1.5 0 01-1.356 1.493l-.144.007H28.96A3.5 3.5 0 0122.035 27h-6.07a3.502 3.502 0 01-6.929 0H7.5a1.5 1.5 0 01-1.493-1.356L6 25.5V13H4.5a.5.5 0 010-1H6v-2H3.5a.5.5 0 010-1H6V7H2.5a.5.5 0 010-1h22zm-12 18a2.5 2.5 0 000 5 2.5 2.5 0 000-5zm13 0a2.5 2.5 0 000 5 2.5 2.5 0 000-5zm7.501-7.003H26v6.039a3.5 3.5 0 012.968 2.99h3.534a.5.5 0 00.492-.41l.008-.09L33 16.998zM24.5 7H7v2h2.5a.5.5 0 010 1H7v2h1.5a.5.5 0 010 1H7v12.5a.5.5 0 00.41.492L7.5 26h1.535a3.502 3.502 0 016.93 0h6.07A3.504 3.504 0 0125 23.035V7.5a.5.5 0 00-.41-.492L24.5 7zm5.271 5.026H26v3.971h7.001v-.261l-3.23-3.71z"></path>
    </IconSvg>
  );
}
